import type { App } from 'vue'
import { createPinia } from 'pinia'
import { setWarehouseCode, warehouseCodeKey } from '@/utils/warehouseCode'

const store = createPinia()

/**
 * 检查页面区域仓warehouse_code参数
 */
export function checkWarehouseCode() {
  const searchParams = new URLSearchParams(location.search.replaceAll('?', '&'))
  if (searchParams.has(warehouseCodeKey)) {
    const code = searchParams.get(warehouseCodeKey)
    code && setWarehouseCode(code)
  }
}

export function setupStore(app: App) {
  checkWarehouseCode()
  app.use(store)
}

export { store }
